var _path;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.609 6.75c-1.514 0-2.023.098-2.546.378a2.23 2.23 0 0 0-.935.935c-.28.523-.378 1.032-.378 2.545v2.784c0 1.513.098 2.023.378 2.545.218.408.527.717.935.935.523.28 1.032.378 2.545.378h2.784c1.513 0 2.023-.098 2.545-.378q.61-.325.935-.935c.28-.522.378-1.032.378-2.545v-2.783c0-1.514-.098-2.023-.378-2.546a2.23 2.23 0 0 0-.935-.935c-.522-.28-1.032-.378-2.545-.378zm0-1.75h2.783c1.95 0 2.657.203 3.37.584.713.382 1.272.941 1.654 1.654.38.713.584 1.42.584 3.37v2.784c0 1.95-.203 2.657-.584 3.37a3.97 3.97 0 0 1-1.654 1.654c-.713.38-1.42.584-3.37.584h-2.783c-1.95 0-2.658-.203-3.37-.584a3.98 3.98 0 0 1-1.655-1.654c-.38-.713-.584-1.42-.584-3.37v-2.783c0-1.95.203-2.658.584-3.37a3.98 3.98 0 0 1 1.654-1.655c.713-.38 1.42-.584 3.37-.584m4.454 3.063a.875.875 0 1 1 0 1.75.875.875 0 0 1 0-1.75M12 9.375a2.625 2.625 0 1 1 0 5.25 2.625 2.625 0 0 1 0-5.25"
})));
export default SvgInstagram;